// inv/src/components/lists/ListService.jsx
import axios from 'axios';
import { API_URL } from '../../config';

export const getArticleBySlug = async (slug) => {
  const res = await fetch(`${API_URL}/lists/${slug}`);
  return res.json();
};

export const getOtherArticles = async (slug, limit = 5) => {
  const res = await fetch(`${API_URL}/lists?excludeSlug=${slug}&limit=${limit}`);
  return res.json();
};

export const getInvestors = async (country, industries, page = 1, limit = 10, types = []) => {
  try {
    const params = { page, limit };

    if (country) params.country = country;
    if (industries) params.industries = industries;

    const safeTypes = Array.isArray(types)
      ? types
      : typeof types === 'string'
        ? [types]
        : [];

    if (safeTypes.length > 0) {
      params.types = safeTypes.join(',');
    }

    const response = await axios.get(`${API_URL}/investors-limited`, { params });

    return {
      data: response.data.investors || [],
      total: response.data.totalCount || 0,
    };
  } catch (error) {
    console.error('Error fetching investors:', error);
    return { data: [], total: 0 };
  }
};
